import { defineNuxtPlugin } from "nuxt/app"
import { setOptions } from 'filepond'
import vueFilePond from 'vue-filepond'

// Import FilePond plugins and styles
import "filepond/dist/filepond.min.css"
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css"

import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type"
import FilePondPluginImagePreview from "filepond-plugin-image-preview"
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size"

// Register FilePond plugins
const FilePond = vueFilePond(
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

// Register as a global component (client only)
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('FilePond', FilePond)

  setOptions({
    server: {
      load: (source, load, error) => {
        fetch(source, { mode: 'cors' })
          .then((res) => res.blob())
          .then((blob) => load(blob))
          .catch(error)
      },
    },
  })
})
